import { FinalNode, FinalGroupNode } from 'utils/adl-services';
import {
  FAILURE,
  REASON_QUESTIONNAIRE_QUOTA_FULL,
  REASON_SCREENING_QUOTA_FULL,
  REASON_SCREENOUT,
  SUCCESS,
} from './constants';

const SCREENING_REASONS = [REASON_SCREENOUT, REASON_SCREENING_QUOTA_FULL];
const QUOTA_FULL_REASONS = [
  REASON_SCREENING_QUOTA_FULL,
  REASON_QUESTIONNAIRE_QUOTA_FULL,
];

export function getOutcomeSuccess(nextNode) {
  return {
    params: {
      id: nextNode,
    },
    type: SUCCESS,
    reason: undefined,
  };
}

export function getOutcomeFailure(reason) {
  return {
    params: {
      id: FinalNode,
    },
    type: FAILURE,
    reason,
  };
}

export function isEndNodeOutcome(outcomeParams) {
  return outcomeParams.id === FinalNode;
}

export function isEndGroupNodeOutcome(outcomeParams) {
  return outcomeParams.id === FinalGroupNode;
}

export function isScreeningStatement(statement) {
  return SCREENING_REASONS.includes(statement?.outcome?.reason);
}

export function isQuotaFullReason(reason) {
  return QUOTA_FULL_REASONS.includes(reason);
}

export function getDefaultStatementDropdownWidth(hasRule, hasSiblings) {
  if (hasRule) {
    return 454;
  }

  return hasSiblings ? 387 : 426;
}
